import React, {useState, useEffect} from 'react'
import {Input} from 'antd'
import {KTSVG} from '../../../../../_metronic/helpers'

interface Props {
  callback: (e: null | string) => void
  loading?: boolean
  disabled?: boolean
}

const Search: React.FC<Props> = (props) => {
  const {callback, loading = false, disabled = false} = props

  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(value)
  }, [value])

  const onClear = (e: any) => {
    setValue('')
    callback(null)
  }

  const onKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      callback(value)
    }
  }
  return (
    <Input
      type='text'
      // className='mb-3'
      size='large'
      style={{borderRadius: 0}}
      disabled={disabled || loading}
      prefix={<KTSVG path='/media/icons/duotune/general/gen021.svg' className='me-1' />}
      suffix={
        value && (
          <div onClick={onClear}>
            <i className='fa fa-times-circle fs-7 cursor-pointer' aria-hidden='true'></i>
          </div>
        )
      }
      value={value}
      onChange={(event) => setValue(event.target.value)}
      onKeyDown={onKeyPress}
      placeholder='Search'
    />
  )
}

export {Search}
